var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgHeading3 = function SvgHeading3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heading-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M12.582 4.302v15.329M12.246 11.732H1.853M1.64 19.631V4.302",
    className: "icon-stroke-width"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.97 18.521c0 1.209 1.516 2.322 3.493 2.322 2.205 0 3.758-1.223 3.758-2.974 0-1.267-.916-2.307-2.132-2.424v-.124c1.011-.147 1.824-1.143 1.824-2.227 0-1.56-1.42-2.651-3.442-2.651-1.912 0-3.34 1.076-3.34 2.248 0 .476.337.806.805.806.345 0 .601-.154.82-.52.389-.66.953-.996 1.678-.996.93 0 1.575.55 1.575 1.355 0 .806-.66 1.391-1.56 1.391h-.682c-.446 0-.761.33-.761.77 0 .454.322.783.761.783h.718c1.077 0 1.802.615 1.802 1.524 0 .908-.71 1.501-1.81 1.501-.82 0-1.471-.359-1.896-1.033-.271-.395-.513-.549-.835-.549-.447 0-.776.337-.776.798Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heading-3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeading3);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;